import { render, staticRenderFns } from "./InfoGoodsSwipe.vue?vue&type=template&id=0da1956b&"
import script from "./InfoGoodsSwipe.vue?vue&type=script&lang=js&"
export * from "./InfoGoodsSwipe.vue?vue&type=script&lang=js&"
import style0 from "./InfoGoodsSwipe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports